/**
 * Triggers a flying dot animation from current pointer click to the global cart icon.
 */
export const animateCartFly = (startX, startY) => {
  const cartIcon = document.getElementById('global-cart-icon');
  if (!cartIcon) return;

  const cartRect = cartIcon.getBoundingClientRect();
  const endX = cartRect.left + cartRect.width / 2;
  const endY = cartRect.top + cartRect.height / 2;

  const flyingDot = document.createElement('div');
  flyingDot.style.position = 'fixed';
  flyingDot.style.left = `${startX - 10}px`;
  flyingDot.style.top = `${startY - 10}px`;
  flyingDot.style.width = '24px';
  flyingDot.style.height = '24px';
  flyingDot.style.background = 'linear-gradient(135deg, #0ea5e9 0%, #8b5cf6 100%)';
  flyingDot.style.borderRadius = '50%';
  flyingDot.style.zIndex = '99999';
  flyingDot.style.boxShadow = '0 0 15px rgba(139, 92, 246, 0.8)';
  flyingDot.style.transition = 'all 0.7s cubic-bezier(0.2, 0.8, 0.2, 1)';
  flyingDot.style.pointerEvents = 'none';

  document.body.appendChild(flyingDot);

  // Trigger reflow immediately
  void flyingDot.offsetWidth;

  // Fly towards the target
  flyingDot.style.left = `${endX - 5}px`;
  flyingDot.style.top = `${endY - 5}px`;
  flyingDot.style.transform = 'scale(0.3)';
  flyingDot.style.opacity = '0';

  // Pop animation on the cart icon itself
  setTimeout(() => {
    cartIcon.style.transform = 'scale(1.2)';
    cartIcon.style.transition = 'transform 0.15s ease';
    setTimeout(() => {
      cartIcon.style.transform = 'scale(1)';
    }, 150);
  }, 600); // timing roughly matches the transition end

  // Cleanup
  setTimeout(() => {
    if (document.body.contains(flyingDot)) {
      document.body.removeChild(flyingDot);
    }
  }, 800);
};
